var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 64,
    viewBox: "0 0 53 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5983 27.8785C47.8115 36.3108 45.7639 40.426 39.1316 46.0203C33.8949 55.0995 43.8858 54.3662 43.8892 56.1584C43.8925 57.9507 43.8892 62.0278 43.8892 62.0278H32.9467C32.9467 56.1584 22.9558 56.1584 22.9558 62.0278H12.4891V55.6248C20.577 54.5577 19.1497 46.5539 13.9164 45.4868C8.68307 44.4196 4.03126 38.2123 2.02246 30.0129H19.1497V27.8785H23.9073M51.977 27.8785H23.9073M23.9073 27.8785L16.771 7.60236L28.6649 2.26653L31.2941 9.7367M23.9073 28.4121L35.8013 22.5427L33.5477 16.1397M31.2941 9.7367C31.2941 9.7367 42.9376 3.86743 46.7437 2.26653C50.5498 0.665639 52.7925 7.60227 50.074 8.66953C47.3556 9.73679 33.5477 16.1397 33.5477 16.1397M31.2941 9.7367L33.5477 16.1397M39.1316 24.1434L44.8407 20.9419M4.87701 20.4083L16.2952 24.677M9.63459 14.0053L15.3437 20.4083",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector64);
export default __webpack_public_path__ + "static/media/Vector 64.cd2eabf149060eb2a0f7e867176810b5.svg";
export { ForwardRef as ReactComponent };